<template>
    <div class="block-html-m-b-20">
        <label><strong>{{ label }}:</strong></label>
        <markdown-editor :configs="editor.config" :value="html2" @input="handleInput" ref="markdownEditor" :custom-theme="true"></markdown-editor>
    </div>
</template>

<script>    
    import VueMde from 'vue-simplemde'
    import Vue from 'vue'        

    Vue.use(VueMde);

    export default {       
        name: 'block-html', 
        props: {
            label: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true 
            },
            html: {
                type: String,
                required: true
            }
        },              
        computed: {
            html2() {
                return this.html;
            }
        },
        data() {
            var self = this;
            return {                                   
                editor: {                    
                    config: {
                        toolbar: ["bold", "italic", "heading-2", "heading-3", "|", "unordered-list", "ordered-list", "|", "link" ],                        
                        spellChecker: false,
                        status: false
                    }
                }
            }
        },        
        methods: {           
            handleInput() {
                var self = this;                
                self.$emit('update:html', self.$refs.markdownEditor.simplemde.value());                
            }
        }
    }
</script>

<style>
    @import "https://cdn.rawgit.com/xcatliu/simplemde-theme-dark/master/dist/simplemde-theme-dark.min.css";
    
    .block-html-m-b-20 {
        margin-bottom: 20px;
    }
</style>


// WEBPACK FOOTER //
// _block-html.vue?6dd66130